import { FileText, Presentation, BookOpen, MessageSquare, Wand2, Download } from "lucide-react";

const features = [
  {
    icon: FileText,
    title: "Text Extraction",
    description: "Converts your handwritten notes into clean, editable digital text using advanced OCR.",
    color: "bg-blue-500/10 text-blue-600",
  },
  {
    icon: Wand2,
    title: "Assignment Generator",
    description: "AI generates complete assignment answers based on your notes and topic.",
    color: "bg-purple-500/10 text-purple-600",
  },
  {
    icon: Presentation,
    title: "PPT Creator",
    description: "Automatically creates presentation slides from your notes with proper formatting.",
    color: "bg-orange-500/10 text-orange-600",
  },
  {
    icon: BookOpen,
    title: "Long & Short Answers",
    description: "Get detailed explanations or concise notes — perfect for exams.",
    color: "bg-green-500/10 text-green-600",
  },
  {
    icon: MessageSquare,
    title: "Topic Explainer",
    description: "Don't understand something? AI explains any concept in simple terms.",
    color: "bg-pink-500/10 text-pink-600",
  },
  {
    icon: Download,
    title: "Export Anywhere",
    description: "Download as PDF, Word, or PPT. Share directly to Google Drive.",
    color: "bg-teal-500/10 text-teal-600",
  },
];

const Features = () => {
  return (
    <section id="features" className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-primary font-semibold text-sm uppercase tracking-wider">Features</span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mt-2 mb-4">
            Everything You Need to Ace Your Studies
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            From messy notes to polished assignments in minutes. 
            Our AI does the heavy lifting so you can focus on learning.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className="group gradient-card rounded-2xl p-6 shadow-card hover:shadow-glow transition-all duration-300 hover:scale-[1.02] border border-border/50"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className={`w-12 h-12 rounded-xl ${feature.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <feature.icon className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-semibold text-foreground mb-2">
                {feature.title}
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
